import { useLayoutEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const getMatches = (query: string) => window.matchMedia(query).matches;

  const [matches, setMatches] = useState<boolean>(() => getMatches(query));

  useLayoutEffect(() => {
    const matchMedia = window.matchMedia(query);

    // Handles the change event of the media query.
    const handleChange = () => {
      setMatches(getMatches(query));
    };

    // Triggered at the first client-side load and if query changes
    handleChange();

    matchMedia.addEventListener('change', handleChange);

    return () => {
      matchMedia.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
}
